import { z } from "zod";

import { LocationMapSchema } from "@widgets/contact-map-card";

import { RulesObjectSchema } from "@features/rules-section/model";

import { DocumentSourceSchema } from "@entities/document";

import {
  ButtonBaseSchema,
  ColorIconSchema,
} from "@shared/content-types/schemas/common.schema";
import {
  RowsShema,
  TableRowsShema,
} from "@shared/content-types/schemas/dynamicZone.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { RichTextSchema } from "@shared/content-types/schemas/richText.schema";

export const InstructorsFormSchema = z.object({
  fullName: z.string().trim().min(1, "Укажите имя и фамилию"),
  time: z.string(),
  type: z.string(),
  comment: z.string().trim().max(500, "Максимум 500 символов").optional(),
  consent: z
    .boolean()
    .refine((val) => val === true, "Подтвердите согласие на обработку данных"),
});

export const AccordionSchema = z.object({
  id: z.number().int().positive(),
  title: z.string().min(1),
  content: RichTextSchema,
});

export const FAQSectionSchema = z.object({
  id: z.number().int().positive(),
  subtitle: z.string().min(1),
  titleWithIcon: TitleWithIconSchema,
  description: RichTextSchema,
  faqContent: z.array(AccordionSchema),
});

export const PricingPlansSchema = z.object({
  id: z.number().int().positive(),
  period: z.string().min(1),
  title: z.string().min(1),
  columnRows: z.array(RowsShema),
  columnTitles: z.array(TableRowsShema),
});

export const BenefitsSchema = z.object({
  id: z.number().int().positive(),
  description: z.string().min(1),
  title: z.string().min(1),
  mainImage: StrapiMediaSchema,
  icons: ColorIconSchema,
});

export const InfoSectionSchema = z.object({
  id: z.number().int().positive(),
  description: z.string().min(1),
  workTime: z.string().min(1),
  // mainImage: StrapiMediaSchema.optional(),
  benefits: z.array(BenefitsSchema),
});

export const PopupSchema = z.object({
  id: z.number().int().positive(),
  description: z.string().min(1),
  title: z.string().min(1),
  document: DocumentSourceSchema,
});

export const InstructorsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  description: z.string().min(1),
  priceText: z.string().min(1),
  heroLeftButton: ButtonBaseSchema,
  heroRightButton: ButtonBaseSchema,
  titleWithIcon: TitleWithIconSchema,
  mainInfoImage: StrapiMediaSchema.optional(),
  info: InfoSectionSchema,
  pricingPlans: z.array(PricingPlansSchema),
  faq: FAQSectionSchema,
  rulesSection: RulesObjectSchema,
  popup: PopupSchema,
  contactMapSection: LocationMapSchema,
});
